import React, {useRef} from 'react';
import 'swiper/swiper-bundle.css';
import SystemMessage from './systemMessage';
import {useSelector} from 'react-redux';
import Swiper from '../../../../../component/swiper/swiper';
import * as css from './systemMessage.css';
import {TSystemMessage} from '../../../../../redux/realtime/realtime.type';
import SystemMessageTopPopup from './SystemMessageTopPopup';

function SystemMessageSwiper({isPop, defaultMessages = null, closePop}:{isPop: boolean, defaultMessages?:TSystemMessage[], closePop?: () => void}){

    const swiperRef = useRef(null);
    const messages: TSystemMessage[] = defaultMessages || useSelector((s:any) => s.realtime.systemMessage[`${isPop?'pop':'window'}Messages`]);
    const isPreview = !!defaultMessages;
    const autoplay={
        delay: 20000,
        disableOnInteraction: false,
    };
    return (
        <css.swiperWrapper className={isPop? 'message-pop': 'message-window'} >
            <Swiper autoplay={autoplay} navigation={true} spaceBetween={30} speed={600} pagination={{class:'system-message', clickable: true}} swiperRef={swiperRef} >
                {messages?.map((sm, i)=>
                    <React.Fragment key={i}>
                        {isPop && <SystemMessageTopPopup closePop={closePop} title={sm.title} />}

                        <css.messageWrapper $isPop={isPop}  image={(isPop && sm?.image && sm?.formType !== 'imageAndText') ? sm.image : undefined}>
                            <SystemMessage message={sm} isPop={isPop} skipFilter={!isPop || isPreview}/>
                        </css.messageWrapper>
                    </React.Fragment>
                )}
            </Swiper>
        </css.swiperWrapper>
    );
}

export default SystemMessageSwiper;
